export default "__VITE_ASSET__64fc60f6__"